import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "@/pages/categories/Columns"
import AddCategoryModal from "./Model"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import { Breadcrumbs } from "@mui/material"

export default function CategoryList() {
  const breadcrumbs = [
    { label: "Dashboard", url: "/" },
    { label: "Categories" },
  ]
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Categories</h5>

        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </div>

      <CrudProvider>
        <CategoryTable />
      </CrudProvider>
    </>
  )
}

function CategoryTable() {
  const { openDialog } = useCrudContext()

  return (
    <>
      <CustomTable
        label="Categories"
        columns={columns}
        apiPath="category"
        onImport={true}
        onExport={true}
      />

      {openDialog ? <AddCategoryModal /> : null}
    </>
  )
}
